module.exports = __webpack_public_path__ + "static/img/claim-step-1.350e0a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-step-1.svg
// module id = exeq
// module chunks = 1